export default {
  styles: 'Styles',
  text: {
    title: 'Title',
    subtitle: 'Subtitle',
    paragraph: 'Text',
  },
  list: {
    listOrdered: 'Ordered List',
    bulletList: 'Bullet List',
  },
  typography: {
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
  },
  utils: {
    highlight: 'Highlight Color',
    link: 'Insert Link',
  },
};
